import Alpine from 'alpinejs';

Alpine.data('liveSearch', () => ({
  query: '',
  searching: false,

  results: {
    products: [],
    queries: [],
  },

  events: {
    form: {
      ['x-on:click.away']() {
        this.reset();
      },
      ['x-on:keydown.escape']() {
        this.reset();
      },
      ['x-on:live-search:reset.window']() {
        this.reset();
      },
    },
    input: {
      ['x-on:focus']() {
        this.fetchResults();
      },
      ['x-on:click']() {
        this.fetchResults();
      }
    }
  },

  init() {
    this.$watch('query', (value) => {
      this.fetchResults();
    });
  },
  
  get popupVisible() {
    return this.results?.products.length > 0 || this.results?.queries.length > 0;
  },

  reset() {
    this.results.products = [];
    this.results.queries = [];
    this.searching = false;
  },

  fetchResults() {
    if (this.query.length > 0) {
      this.searching = true;
    }

    this.results.products = [];
    this.results.queries = [];

    fetch(
      window.Shopify.routes.root +
        `search/suggest.json?q=${this.query}&resources[type]=query,product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`
    )
      .then((response) => response.json())
      .then((suggestions) => {
        this.results.products = suggestions.resources.results.products;
        this.results.queries = suggestions.resources.results.queries;
      })
      .finally(() => {
        this.searching = false;
      });
  },
}));